import ClaimListTable from "./claimListTable.container";

export default ClaimListTable;
